var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef, Fragment } from 'react';
import { DropdownButton } from './DropdownButton';
import { Align } from '../util/getRelativePosition';
import { DropdownMenuItem } from './DropdownMenu';
import { Divider } from './Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
export var UserMenu = function (_a) {
    var user = _a.user, onSignOut = _a.onSignOut, className = _a.className, children = _a.children;
    return (jsx(DropdownButton, { as: UserToggle, className: className, text: null, align: Align.End },
        jsx(DropdownMenuItem, { sx: { fontWeight: 'bold' } }, user.name),
        jsx(DropdownMenuItem, { onClick: onSignOut }, "Sign out"),
        children && (jsx(Fragment, null,
            jsx(Divider, null),
            children))));
};
var UserToggle = forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (jsx("div", __assign({ ref: ref, sx: {
            width: '2.3em',
            lineHeight: 2.3,
            textAlign: 'center',
            borderRadius: '50%',
            fontWeight: 'bold',
            cursor: 'pointer',
        }, className: className }, props),
        jsx(FontAwesomeIcon, { icon: faUser })));
});
//# sourceMappingURL=UserMenu.js.map